import React from 'react';
import { Paper } from '@mui/material';

// Each form section sits in its own outlined card on the page background.
// Flattening to sibling cards (rather than one giant Paper wrapping nested
// boxes) gives the long form visual rhythm and keeps the hierarchy flat.
// Radius is inherited from the theme's 12px Paper token — no override.
export const SectionCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderColor: 'divider' }}>
    {children}
  </Paper>
);
